<template>
  <div>
    <div v-if="loadingStatus">
      <v-col cols="12" md="10" sm="10" class="mx-auto">
        <v-skeleton-loader
          :loading="loadingStatus"
          class="ma-2"
          type="card@6"
          elevation="2"
        >
        </v-skeleton-loader>
      </v-col>
    </div>

    <v-sheet v-else elevation="2" class="news-sheet">
      <v-col
        cols="12"
        md="10"
        sm="10"
        class="mx-auto"
        v-for="news in displayedNews"
        :key="news._id"
      >
        <!-- <base-title-bar
          elevation="2"
          class="text-center"
          color="#17408B"
          :label="`${news.Title}`"
          icon="mdi-hockey-sticks"
          height="60"
          textProp="pt-2 pb-1text-subtitle-1 white--text"
        /> -->

        <!--//* goalies cards.. -->
        <v-card class="mx-auto" rounded elevation="2">
          <v-card-text>
            <span class="caption font-weight-black">
              {{ news.Updated | UtcToEst }}
            </span>
            <v-avatar
              color="grey"
              class="float-left mx-2"
              width="50"
              height="50"
            >
              <img :src="news.Teamlogo" />
            </v-avatar>
            <p class="text-subtitle-1 font-weight-bold">{{ news.Title }}</p>
            <p>{{ news.Content }}</p>
            <p v-if="news.Source" class="caption grey--text mb-0">
              Source: {{ news.Source }}
            </p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        v-if="shouldShowViewMore"
        cols="12"
        md="10"
        sm="10"
        class="mx-auto text-center pb-4"
      >
        <v-btn
          color="green darken-1"
          dark
          @click="showSubscriptionModal = true"
        >
          View More
        </v-btn>
      </v-col>
    </v-sheet>

    <news-subscription-modal
      :showModal="showSubscriptionModal"
      @close="showSubscriptionModal = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import NewsSubscriptionModal from "@/components/Modal/NewsSubscriptionModal.vue";

export default {
  name: "NhlNewsPage",

  components: {
    NewsSubscriptionModal,
  },

  created() {
    this.fetchNhlNews();
  },

  data() {
    return {
      showSubscriptionModal: false,
    };
  },

  computed: {
    ...mapState("NhlModule", ["nhlNews", "loadingStatus"]),
    ...mapState("userModule", ["userState"]),

    planType() {
      return this.userState?.plantype || localStorage.getItem("planType") || "";
    },

    isFreeUser() {
      return this.planType === "Free" || this.planType === "";
    },

    displayedNews() {
      if (!this.nhlNews.data) return [];

      if (this.isFreeUser) {
        return this.nhlNews.data.slice(0, 5);
      }
      return this.nhlNews.data;
    },

    shouldShowViewMore() {
      return this.isFreeUser && this.nhlNews.data && this.nhlNews.data.length > 5;
    },
  },

  methods: {
    fetchNhlNews() {
      this.$store.dispatch("NhlModule/getNhlNewsData");
    },
  },
};
</script>

<style scoped>
.news-sheet {
  background: #c2e6cf !important;
}
</style>
